import BaseComponent from '../../js/base-component';

export default class SearchComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.form = this.refs.form;
        this.record = this.refs.record;

        this.onSubmit = this.onSubmit.bind(this);
    }

    static getRequiredRefs(){
        return ['form', 'record'];
    }

    init(){
        this.form.addEventListener('submit', this.onSubmit);
        document.cookie = 'js_on=1;';
    }

    clickOutSide(event) {
        const isClickInside = this.element.contains(event.target)

        if (!isClickInside) {
            this.element.classList.add('search--hidden');
        }
    }

    onSubmit(e){
        e.preventDefault();
        let rec = (this.record.value.indexOf('//') > -1) ? this.record.value.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n]+)/im)[1] : this.record.value;
        this.form.getAttribute('id') == 'asn-search' ? ipHref === '/blacklist' : ipHref;
        let ipSearchHref =  url_lang_prefix + ipHref + rec;
        location.href = ipSearchHref;
        return false;
    }

    onDestroy(){
        this.form.removeEventListener('submit', this.onSubmit);
    }
}
